export const PRICE = "AED"

// Categories map to the client app modules so admins upload Q&A per module
// and clients can search within a specific module.
export const faqCategory = [
  { label: "General", value: "General" },
  { label: "Calendar", value: "Calendar" },
  { label: "Vault", value: "Vault" },
  { label: "Content Theme", value: "Content Theme" },
  { label: "Research Assistant", value: "Research Assistant" },
  { label: "Writing Assistant", value: "Writing Assistant" },
  { label: "Reports", value: "Reports" },
  { label: "Blog", value: "Blog" },
  { label: "Post", value: "Post" },
  { label: "Notes", value: "Notes" },
]


const currentYear = new Date().getFullYear();
export const globalYears = [
  { label: currentYear - 2, value: currentYear - 2 },
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear, value: currentYear },
  { label: currentYear + 1, value: currentYear + 1 },
];